export default {
    topics: [
        {
            title: ' ConfirmDeletePending ',
            href: 'sm-gdprRequest-ConfirmDeletePending.html',
            attributes: { 'data-id': 'sm-gdprRequest-ConfirmDeletePending' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-ConfirmDeletePending-d66e2924',
            topics: [],
        },
        {
            title: ' CreateRequestByName ',
            href: 'sm-gdprRequest-CreateRequestByName.html',
            attributes: { 'data-id': 'sm-gdprRequest-CreateRequestByName' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-CreateRequestByName-d66e2932',
            topics: [],
        },
        {
            title: ' DeleteRemoteData ',
            href: 'sm-gdprRequest-DeleteRemoteData.html',
            attributes: { 'data-id': 'sm-gdprRequest-DeleteRemoteData' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-DeleteRemoteData-d66e2940',
            topics: [],
        },
    ],
};

